var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 1.33331H4.66683C2.82683 1.33331 1.3335 2.81998 1.3335 4.65331V8.63998V9.30665C1.3335 11.14 2.82683 12.6266 4.66683 12.6266H5.66683C5.84683 12.6266 6.08683 12.7466 6.20016 12.8933L7.20016 14.22C7.64016 14.8066 8.36016 14.8066 8.80016 14.22L9.80016 12.8933C9.92683 12.7266 10.1268 12.6266 10.3335 12.6266H11.3335C13.1735 12.6266 14.6668 11.14 14.6668 9.30665V4.65331C14.6668 2.81998 13.1735 1.33331 11.3335 1.33331ZM8.66683 9.16665H4.66683C4.3935 9.16665 4.16683 8.93998 4.16683 8.66665C4.16683 8.39331 4.3935 8.16665 4.66683 8.16665H8.66683C8.94016 8.16665 9.16683 8.39331 9.16683 8.66665C9.16683 8.93998 8.94016 9.16665 8.66683 9.16665ZM11.3335 5.83331H4.66683C4.3935 5.83331 4.16683 5.60665 4.16683 5.33331C4.16683 5.05998 4.3935 4.83331 4.66683 4.83331H11.3335C11.6068 4.83331 11.8335 5.05998 11.8335 5.33331C11.8335 5.60665 11.6068 5.83331 11.3335 5.83331Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.3c6066ac488d8498249d152cd5795863.svg";
export { ForwardRef as ReactComponent };